import { SET_CUSTOMER } from "./actionTypes"

export const setCustomer = (customer: any) => {
    return {
        type: SET_CUSTOMER,
        payload: customer
    }
}